import React, { useState, useRef, useContext } from 'react';

//*************************Componentes PrimerReact**************************************** */
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';


//*****************************Componentes Generales****************************************** */
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import Loader from '../../../Components/Loader/Loader';

//******************************Consultas API************************************** */

import {getSeleccionCAIsProveedor } from '../../../API/Proveedores/ProveedoresRequest'
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { Checkbox } from 'primereact/checkbox';
const OverlaySeleccionProveedoresCAI = ({ IdProveedor, values, onChange, close, habilitar, RemoverCAI = ()=>{} }) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [proveedoresCAI, setProveedoresCAI] = useState([]);
    const [IdProveedorCAI, setIdProveedorCAI] = useState(0);

    const { userAuth } = useContext(AuthContext)

    const obtenerProveedoresCAI = async () => {
        setLoading(true)
        if (IdProveedor > 0) {
            const result = await getSeleccionCAIsProveedor(IdProveedor)
            if (values?.IdProveedorCAI) {
                if (result?.length > 0) {
                    result.forEach((e) => {
                        if (e?.IdProveedorCAI === values?.IdProveedorCAI) {
                            e.Seleccionado = true
                        } else {
                            e.Seleccionado = false
                        }
                    });
                }
            }
            setProveedoresCAI(result)
        }

        setLoading(false)
    }

    const EstadoCAI = (rowData) => {
        if (rowData.IdEstado === 1) {
            return (
                <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex'>{rowData.StatusName}</span>
            )
        } else {
            return (
                <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex' >{rowData.StatusName}</span>
            )
        }
    }


    const rowClassRules = {
        'ag-rows-partida-blue': (params) => {
            return (params?.data?.Seleccionado === 1 || params?.data?.Seleccionado === true);
        },
    };
    const table = {
        Data: proveedoresCAI,
        rowClassRules: rowClassRules,
        Columns: [
            {
                field: 'IdProveedorCAI',
                header: 'IdProveedorCAI',
                headerEn: 'IdProveedorCAI',
                className: 'Xsmall',
                hidden: userAuth.IdRol === 1,
                frozen:true,
                alignFrozen:'left'
            },
            {
                field: 'NombreSucursal',
                header: 'Nombre Sucursal',
                headerEn: 'Sucursal Name',
                className: 'XXlarge',
                Sumary: 'count',
                frozen:true,
                alignFrozen:'left'
            },
            {
                field: 'Prefijo',
                header: 'Prefijo',
                headerEn: 'Prefijo',
                className: 'small',
            },
            {
                field: 'NoCAI',
                header: 'CAI',
                className: 'XXXlarge',
            },
            {
                field: 'FechaVencimiento',
                header: 'Fecha Vencimiento',
                headerEn: 'Expired Date',
                className: 'small',
                Format: 'Date',
                // sort: 'desc'
            },
            {
                field: 'StatusName',
                header: 'Estado',
                headerEn: 'Status',
                className: 'Xsmall',
                Format: 'Template',
                body: rowData => EstadoCAI(rowData)
            },
            {
                field: 'RangoInicial',
                header: 'Rango Inicial',
                headerEn: 'Rango Inicial',
                className: 'Xsmall',
            },
            {
                field: 'RangoFinal',
                header: 'Rango Final',
                headerEn: 'Rango Final',
                className: 'Xsmall',
            },
            {
                field: 'IdProveedorCAI',
                header: 'Seleccionado ',
                headerEn: 'Seleccionado',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.IdProveedorCAI ? (
                    <div onDoubleClick={(e) => {
                        if (data?.Seleccionado) {
                            RemoverCAI()
                            op.current.toggle(e)
                        }
                    }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={data?.Seleccionado} />
                    </div>
                ) : null,
            },

        ],

        // onCellClicked: e => onChange(e, op)
        onCellClicked: (e) => {
            if (!e?.data?.Seleccionado) {
                onChange(e, op)
            }
        }
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        obtenerProveedoresCAI()
    }


    return (
        <div style={{ maxWidth: '55vw' }}>

            <div className="p-inputgroup">
                <Button ref={buttom} icon='pi pi-chevron-down' type="button" onClick={(e) => openOver(e)} disabled={!habilitar} />
            </div>

            <OverlayPanel ref={op} showCloseIcon dismissable={false} onHide={close} style={{ height: '30vh', width: '70vw' }} >
                <Loader loading={loading} querySelector={'#ProveedoresCAIS'} />
                <div style={{ width: '65vw', height: '30vh' }} id='ProveedoresCAIS'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default OverlaySeleccionProveedoresCAI